import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import * as E from '../../elementor'
import Table from './Table'
import parse from 'html-react-parser'
import SmoothScrollLink from '../transition/smooth-scroll-link'

type Props = {
  section: E.Section<true>
}

const Stats = ({ section }: Props) => {
  const { heading, textEditor, button, table } = E.collect(section)
  const isScrollLink = button[0]?.link !== undefined && button[0]?.link.includes('#');

  return (
    <section>
      <div className='stats-wrapper'>
        <div className='text-content'>
          <div className='text-wrapper'>
            <h2 id="stats-heading">{parse(heading[0]?.title || '')}</h2>
            <p id="stats-subheading" className='paragraph'>{parse(textEditor[0]?.text() || '')}</p>
            <Table table={table[0]} />
            <div className='button-wrapper'>
              {button[0] ? isScrollLink ?
                <SmoothScrollLink offset={0} offsetMobile={0} id={button[0].link as string} className='main-button'><button className='rula-button'>{button[0]?.text}</button></SmoothScrollLink> :
                <AniLink id={button[0]?.button_css_id || ''} className='main-button' fade to={button[0]?.link}><button className='rula-button'>{button[0]?.text}</button></AniLink>
              : null}
              <AniLink id={button[1]?.button_css_id || ''} fade to={button[1]?.link}>
                <button className='rula-secondary-button'>{button[1]?.text}</button>
              </AniLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Stats
